import React from "react";
import { connect } from "react-redux";
import Container2 from "../helpers/Container2";

class DescriptionHeader extends React.Component {
  render() {
    return (
      <div className="description__header">
        <Container2>
          <div
            className={`description__header--wrapper ${
              this.props.darkMode ? "dark--3" : ""
            }`}
          >
            <div className="description__header--col1">
              <div className="description__header--imagebox">
                <img
                  src={this.props.selectedJob.company_logo}
                  className="description__header--image"
                  alt="Logo"
                />
              </div>
              <div className="description__header--col1--inner">
                <h2
                  className={`description__header--title ${
                    this.props.darkMode ? "white" : ""
                  }`}
                >
                  {this.props.selectedJob.company}
                </h2>
                <p className="description__header--companysite">
                  {this.props.selectedJob.company_url}
                </p>
              </div>
            </div>
            <div className="description__header--col2">
              <a
                href={this.props.selectedJob.company_url}
                className={`btn btn--description  ${
                  this.props.darkMode ? "dark--2-btn" : ""
                }`}
              >
                Company Site
              </a>
            </div>
          </div>
        </Container2>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedJob: state.selectedJob,
    darkMode: state.darkMode,
  };
};

export default connect(mapStateToProps)(DescriptionHeader);
